import React from 'react';
import Hero from '../components/help-tutorial/Hero';
import GettingStart from '../components/help-tutorial/GettingStart';

const HelpTutorial = () => {
  return (
    <div>
      <Hero/>
      <GettingStart/>
    </div>
  );
};

export default HelpTutorial;
